import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { boardingCertificateCommonReducer } from './boarding-certificate-common.reducer';
import {
  BOARDING_CERTIFICATE_COMMON_STORE_NAME,
  BoardingCertificateCommonState,
} from './boarding-certificate-common.state';

/** Token of the BoardingCertificateCommon reducer */
export const BOARDING_CERTIFICATE_COMMON_REDUCER_TOKEN = new InjectionToken<
  ActionReducer<BoardingCertificateCommonState, Action>
>('Feature BoardingCertificateCommon Reducer');

/** Provide default reducer for BoardingCertificateCommon store */
export function getDefaultBoardingCertificateCommonReducer() {
  return boardingCertificateCommonReducer;
}

@NgModule({
  imports: [StoreModule.forFeature(BOARDING_CERTIFICATE_COMMON_STORE_NAME, BOARDING_CERTIFICATE_COMMON_REDUCER_TOKEN)],
  providers: [
    { provide: BOARDING_CERTIFICATE_COMMON_REDUCER_TOKEN, useFactory: getDefaultBoardingCertificateCommonReducer },
  ],
})
export class BoardingCertificateCommonStoreModule {
  public static forRoot<T extends BoardingCertificateCommonState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<BoardingCertificateCommonStoreModule> {
    return {
      ngModule: BoardingCertificateCommonStoreModule,
      providers: [{ provide: BOARDING_CERTIFICATE_COMMON_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
